import {Component, OnInit, Input, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-block-code-editor',
  templateUrl: './block-code-editor.component.html',
  styleUrls: ['./block-code-editor.component.scss']
})
export class BlockCodeEditorComponent implements OnInit {

  @Input() code: any;
  @Input() language = 'javascript';

  @Input() enableLibraries = false;
  @Input() libraries: any;
  @Input() selectedLibraries: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<BlockCodeEditorComponent>) { }

  ngOnInit() {
    if (this.data && this.data.code) {
      this.code = this.data.code;
    }
    if (this.data && this.data.enableLibraries) {
      this.enableLibraries = true;
      if (this.data.libraries) {
        this.libraries = this.data.libraries;
      } else {
        this.libraries = [];
      }

      if (this.data.selectedLibraries) {
        this.selectedLibraries = this.data.selectedLibraries;

        this.selectedLibraries = this.selectedLibraries.filter(selectedLibrary => {
          const library = this.libraries.find(lib => lib.id === selectedLibrary.id);
          return library !== undefined;
        });

        const selectedLibraryIds = [];
        this.selectedLibraries = this.selectedLibraries.filter(selectedLibrary => {
          if (selectedLibraryIds.includes(selectedLibrary.id)) {
            return false;
          } else {
            selectedLibraryIds.push(selectedLibrary.id);
            return true;
          }
        });

        this.selectedLibraries = this.selectedLibraries.map(selectedLibrary => {
          const library = this.libraries.find(lib => lib.id === selectedLibrary.id);
          return library ? library : selectedLibrary;
        });


      } else {
        this.selectedLibraries = [];
      }
    }
    if (this.data && this.data.language) {
      if (this.data.language === 'JAVASCRIPT') {
        this.language = 'javascript';
      } else if (this.data.language === 'PYTHON') {
        this.language = 'python';
      }
    }
  }

  returnCode() {
    this.dialogRef.close({code: this.code, selectedLibraries: this.selectedLibraries});
  }

}
